module.exports = __webpack_public_path__ + "media/images/core_values/consistency-24ac4acfec7f7ca2b8e2c29c6a142a1b.png";